/* eslint-disable @typescript-eslint/no-unused-expressions */
import { IColumnModel, ColumnModel } from 'table-editor';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { Regiment } from './regiment';
import { BranchOfService } from './branchOfService';
import { State } from './state';
import { WriteOrdinalSuffixOfNumber, NumericSortArrayByProperty } from 'starbase-launcher';

export enum UnitArmies {
  Unknown = 0,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  US = 1,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  CS = 2
}

export const UnitArmiesDisplay = [ 'N/A', 'US', 'CS' ];

/** Links a collection of unit-defining properties to a particular Image Record. */
export class UnitLinking {

  public uid: number;
  public army: UnitArmies;
  public corps: number;
  public imageModelId: number;
  public regimentNoId: number;
  public regimentNo: Regiment;
  public stateId: number;
  public state: State;
  public branchId: number;
  public branch: BranchOfService;
  public companyLetters: string;
  public branchName: string;
  public stateName: string;
  public regimentNumberDisplay: any;
  public corpsDisplay: any;
  public armyDisplay: any;

  public static unitLinkingColumnData(regiments: Regiment[],
    states: State[],
    branches: BranchOfService[],
    corpsData: object[]): IColumnModel[] {
    regiments.forEach(r => {
      r.regimentNumberDisplay = WriteOrdinalSuffixOfNumber(r.regimentNo);
    });
    regiments = NumericSortArrayByProperty(regiments, 'regimentNo');
    corpsData.forEach(c => {
      // c['val'] = c['corps'];
      // c['corps'] = WriteOrdinalSuffixOfNumber(c['corps']);
    });
    states.forEach(s => {
      s['stateName'] = s.state_Name;
    });
    const unitArmies = this.deconstructArmiesEnum();
    return [
      new ColumnModel('ImageModel ID', 'imageModelId', 'ImageModelId', false, 'number', false, false, 10, false, null, null, 0),
      new ColumnModel('UnitModel ID', 'unitModelId', 'UnitModelId', false, 'number', false, false, 10, false, null, null, 0),
      new ColumnModel('Army', 'army', 'armyDisplay', true, 'dropdown', false, false, 1, true, unitArmies, 'army', null, null, null, false, false),
      new ColumnModel('Corps', 'corps', 'Corps', true, 'dropdown', false, false, 1, true, corpsData, 'corps', null, null, null, null, false),
      new ColumnModel('Regiment', 'regimentNumber', 'regimentNumberDisplay', true, 'dropdown', false, false, 2, true, regiments, 'regimentNumberDisplay', null, null, null, null, false),
      new ColumnModel('State', 'stateName', 'stateName', true, 'dropdown', false, false, 2, true, states, 'stateName', null, null, null, null, false),
      new ColumnModel('Branch', 'branchName', 'branchName', true, 'dropdown', false, false, 2, true, branches, 'branchName', null, null, null, null, false),
      new ColumnModel('Co. Letters', 'companyLetters', 'CompanyLetters', true, 'string', false, false, 50, true)
    ];
  }
  public static setupUnitLinkCollection(collection: UnitLinking[]): void {
    if (!collection) {
 return;
}
    if (collection.length === 0) {
 return;
}
    const unitArmies = this.deconstructArmiesEnum();
    of(collection).pipe(
      map((u: UnitLinking[]) =>
        u.map(
          (k: UnitLinking) => {
            k.regimentNo ? k.regimentNo = new Regiment().deserialize(k.regimentNo) : k.regimentNo = null;
            k.state ? k.state = new State().deserialize(k.state) : k.state = null;
            k.branch ? k.branch = new BranchOfService().deserialize(k.branch) : k.branch = null;
            k.regimentNo ? k.regimentNumberDisplay = WriteOrdinalSuffixOfNumber(k.regimentNo.regimentNo) : k.regimentNumberDisplay = null;
            k.state ? k.stateName = k.state.state_Name : k.stateName = null;
            k.branch ? k.branchName = k.branch.branchName : k.branchName = null;
            k.corpsDisplay = k.corps ? WriteOrdinalSuffixOfNumber(k.corps) : null;
            k.armyDisplay = k.army ? unitArmies[k.army] : null;
          }
        ))
    ).subscribe();
  }
  private static deconstructArmiesEnum(): { army: string; val: number }[] {
    let unitArmies: { army: string; val: number }[] = Object.keys(UnitArmies).filter(a =>
      !(parseInt(a, 10) >= 0)).map(a => ({ army: a, val: UnitArmies[a] }));
    unitArmies = unitArmies.filter(x => x.val != 0);
    unitArmies.unshift({ army: '', val: 0 });
    return unitArmies;
  }
}
